import { render, staticRenderFns } from "./ManualCreate.vue?vue&type=template&id=60fb0b6c&scoped=true"
import script from "./ManualCreate.vue?vue&type=script&lang=js"
export * from "./ManualCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb0b6c",
  null
  
)

export default component.exports